import { useEffect, useState } from 'react';
import { register, applyUpdate } from '../serviceWorkerRegistration';

/**
 * Offers a waiting service worker to the user instead of activating it behind
 * their back (FR-031).
 *
 * A silent `skipWaiting()` can swap the app shell mid-chapter while audio is
 * playing. It also leaves no way to tell a stuck worker from a working one.
 * Without this prompt a worker that installed behind an older one waits
 * indefinitely, and offline quietly keeps using the previous version.
 */
const UpdatePrompt = () => {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    register({ onUpdateAvailable: setRegistration });
  }, []);

  if (!registration) return null;

  return (
    <div role="alert" className="flex items-center justify-between gap-4 bg-primary px-4 py-2 text-sm text-white">
      <span>A new version of Dissona is ready.</span>
      <button
        type="button"
        onClick={() => applyUpdate(registration)}
        className="rounded-lg bg-white/20 px-3 py-1 font-medium transition-colors hover:bg-white/30"
      >
        Reload
      </button>
    </div>
  );
};

export default UpdatePrompt;
